import { Badge } from "@/components/ui/badge";

/**
 * Get the appropriate badge variant for a lease status
 */
export function getLeaseStatusVariant(
  status: string
): "default" | "secondary" | "outline" | "destructive" | "success" | "warning" {
  switch (status) {
    case "active":
      return "success"; // Green for active leases
    case "pending_signatures":
    case "pending_tenant_signup":
      return "warning"; // Yellow for pending actions
    case "expired":
      return "outline"; // Gray for expired
    case "terminated":
      return "destructive"; // Red for terminated
    default:
      return "outline";
  }
}

/**
 * Format lease status for display
 */
export function formatLeaseStatus(status: string): string {
  switch (status) {
    case "pending_signatures":
      return "Pending Signatures";
    case "pending_tenant_signup":
      return "Pending Signup";
    case "active":
      return "Active";
    case "expired":
      return "Expired";
    case "terminated":
      return "Terminated";
    default:
      return status
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
  }
}

/**
 * Render a status badge for a lease
 */
export function LeaseStatusBadge({ status }: { status: string }) {
  return (
    <Badge variant={getLeaseStatusVariant(status)}>
      {formatLeaseStatus(status)}
    </Badge>
  );
}
